import { fetchData } from "./fetchData";

export const getRunsAPI = async(jobId) => {
    const route = `/runs?jobid=${jobId}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

export const createRunAPI = async(runData) => {

    const route = "/runs";

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(runData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const updateRunAPI = async(runData) => {

    const route = `/runs/${runData.RunID}`;

    const options = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(runData)
    }

    let response = await fetchData(route, options);

    return response;
}

export const getRunByIDAPI = async(runID) => {
    const route = `/runs/${runID}`;

    const options = {
        method: 'GET'
    }

    let response = await fetchData(route, options);

    return response;
}

export const deleteRunAPI = async(RunID) => {

    const route = `/runs/${RunID}`;

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
    }

    let response = await fetchData(route, options);

    return response;
}

export const archiveRun = async(RunID) => {
    const route = `/runs/archive/${RunID}`;

    const options = {
        method: 'PUT',
    }

    let response = await fetchData(route, options);

    return response;
}

//run messages
export const getRunMessagesAPI = async(RunID) => {
    const route = `/runs/messages/${RunID}`;

    const options = {
        method: 'GET',
    }

    let response = await fetchData(route, options);

    return response;
}

export const createRunMessageAPI = async(RunID, messageData) => {
    const route = `/runs/messages/${RunID}`;

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(messageData)
    }

    let response = await fetchData(route, options);

    return response;
}